<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name"></sui-page-header>
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PORTL')" :vertical="false" />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
                ref="comboPortals"
                :selected="frame0.selectData.portals"
                :option-list="frame0.selectPortalList"
                :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_SITE')" :vertical="false" />
          </div>
          <div class="col-xs-3">

            <cmp-site-select
                ref="comboSites"
                :pageId="this.$options.name"
                :selected="frame0.selectData.site"
                :initialSelectedIndex="0"
                @list-clicked="onSiteSelect"
                @loaded="onSitesLoad"
            />

          </div>
          <div class="btn_wrap">
            <sui-button
                type="button"
                class="comm_btn_Reset"
                @click="onResetSearchClick">{{ $t('MSG_BTN_RESET') }}</sui-button>
            <sui-button
                v-permission:read="this.$options.name"
                type="button"
                class="comm_btn_Scr"
                @click="onSearchClick">{{ $t('MSG_BTN_SEARCH') }}</sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30"></div>
      <div class="comm_shut_wrap">
        <div class="inbox1">
          <div class="comm_title_wrap">
            <h4>{{ $t('MSG_TXT_APPLICATION') }}</h4>
          </div>
          <sui-grid ref="appGrid"
                :showDisplayCountControl="false"
                :initialPagesize="10"
                :columns="gridColumns0"
                :dataset="'dsSiteMenuAppList'"
                @rowselect="onRowSelect"
          >
          </sui-grid>
        </div>
        <div class="btnbox">
        </div>
        <div class="inbox2">
          <div class="comm_title_wrap">
            <h4 class="comm_tit02">
              {{ $t('MSG_TXT_MENU') }}
            </h4>
          </div>
          <div class="comm_gridTop_wrap">
            <div class="btn_wrapR">
              
                <cmp-site-select
                    ref="comboCopySites"
                    :pageId="this.$options.name"
                    :selected="frame0.selectData.copySite"
                    :defaultOption="'select'"
                    :initialSelectedIndex="0"
                    :disabled="cmpStatus.copySelect"
                />
                <!--    @list-clicked="onSiteSelect"
                />-->
              
              <sui-button
                  v-permission:read="this.$options.name"
                  type="button"
                  class="comm_btn_gridTop"
                  @click="onCopySiteMenuClick"
                  :disabled="cmpStatus.copyBtn"
              >
                {{ $t('MSG_BTN_GET') }}
              </sui-button>
            </div>
          </div>
          <sui-tree-grid
              ref="treeGrid01"
              :columns="treeGridColumns01"
              :dataset="'dsSiteMenuList'"
              :height="395"
              :selectionMode="'singleRow'"
              :checkboxes="true"
              :hierarchicalCheckboxes="false"
              @rowCheck="onRowCheckTreeGrid"
              @rowUncheck="onRowUncheckTreeGrid"
          />
        </div>
      </div>
      <div class="comm_btn_wrap">
        <sui-button
            v-permission:update="this.$options.name"
            type="button"
            class="comm_btn_solid"
            @click="onSaveClick"
            :disabled="cmpStatus.saveBtn">
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMP_00010', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      localLangId: this.$store.getters.userInfo.langId,
      // Codes
      codes: CommonConstants.selectOptions(),
      selectedGridRowData: {},
      currAppId: '',
      currSiteId: '',
      cmpStatus: {
        copySelect: true,
        copyBtn: true,
        saveBtn: true,
      },
      frame0: {
        selectData: {
          portals: {},
          site: {},
          copySite: {},
        },
        selectPortalList: [],
      },
      localdata0: [],
      gridColumns0: [
        {
          text: this.$t('MSG_TXT_APPLICATION_ID'),
          datafield: 'applicationId',
        }, {
          text: this.$t('MSG_TXT_APPLICATION_NM'),
          datafield: 'applicationName',
        },
      ],
      localdata1: [],
      localdata1_ori: [],
      treeGridColumns01: [{
        text: this.$t('MSG_TXT_MENU_NAME'),
        datafield: 'menuName',
        width: 250,
      }, {
        text: this.$t('MSG_TXT_PAGE_ID'),
        datafield: 'pageId',
        width: 130,
      }, {
        text: this.$t('MSG_TXT_PAGE_NM'),
        datafield: 'pageName',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'm_userName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_KNOX_ID'),
        datafield: 'm_knoxId',
        width: 120,
      }, {
        text: this.$t('MSG_TXT_FNL_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: 150,
        cellsrenderer: (r, c, v) => `<div class="jqx-grid-cell-left-align" style="margin-top: 10.5px;">${utils.dateformatToClient(v)}</div>`,
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsSiteMenuAppList',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'applicationId', type: 'string', map: 'applicationId' },
      { name: 'applicationName', type: 'string', map: 'applicationName' },
    ],
  }, {
    id: 'dsSiteMenuList',
    componentType: 'tree-grid',
    // type: 'local',
    data: 'localdata1',
    hierarchy: {
      keyDataField: {
        name: 'menuUid',
      },
      parentDataField: {
        name: 'parentsMenuUid',
      },
    },
    datafields: [
      { name: 'menuUid', type: 'string', map: 'menuUid' },
      { name: 'parentsMenuUid', type: 'string', map: 'parentsMenuUid' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'menuLevel', type: 'string', map: 'menuLevel' },
      { name: 'menuName', type: 'string', map: 'menuName' },
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'pageName', type: 'string', map: 'pageName' },
      { name: 'm_knoxId', type: 'string', map: 'm_knoxId' },
      { name: 'm_userName', type: 'string', map: 'm_userName' },
      // { name: 'm_userGlobalName', type: 'string', map: 'm_userGlobalName' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'deleteYn', type: 'string', map: 'deleteYn' },
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      // { name: 'folderYn', type: 'string', map: 'folderYn' },
    ],
  }],
  mounted() {
    // this.localLangId = this.$store.getters.userInfo.langId;
    // portal list
    http.request(this.$options.name, 'DTS_CMP_00004')
      .then(res => {
        utils.forEach(res.data, obj => {
          this.frame0.selectPortalList.push({
            key: obj.portalId,
            label: obj.portalName,
          });
        });
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    makeSnapshot() {
      const snapshotData = utils.assign({}, this.$refs.treeGrid01.getJqxTreeGrid().getCheckedRows());
      return snapshotData;
    },
    onSitesLoad(obj) {
      this.currSiteId = obj[0].key;
    },
    onSearchClick() {
      this.currAppId = '';
      const searchValue = this.frame0.selectData;
      const queryParams = {
        portalId: utils.trim(searchValue.portals.key) || '',
      };
      // validation
      if (!this.formValidate()) return false;

      http.request(this.$options.name, 'DTS_CMP_00005', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;
        this.dsSiteMenuAppList.setRawData(this.localdata0);

        this.dsSiteMenuAppList.clearSelection();
        if (this.dsSiteMenuAppList.data.length > 0) {
          this.dsSiteMenuAppList.setSelectedIndexes([0]);
        }
        this.dsSiteMenuList.setRawData([]);
      }).catch(error => {
        console.log(error);
      });
    },
    formValidate() {
      if (!utils.trim(this.frame0.selectData.portals.key) || this.frame0.selectData.portals.key === 'ALL') {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PORTL'));
        utils.messageBox('warning', msg);

        return false;
      }
      if (!utils.trim(this.frame0.selectData.site.key)) {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SITE'));
        utils.messageBox('warning', msg);

        return false;
      }
      return true;
    },
    onResetSearchClick() {
      this.selectedGridRowData = {};
      this.currAppId = '';
      this.$refs.comboPortals.reset();
      this.$refs.comboSites.reset();
    },
    onRowSelect(target) {
      // const selectIdx = target.args.rowindex;
      const selectIdx = typeof target === 'object' ? target.args.rowindex : target;
      if (selectIdx > -1) {
        this.selectedGridRowData = this.localdata0[selectIdx];
        const portalId = this.frame0.selectData.portals.key || '';
        const appId = this.selectedGridRowData.applicationId || '';
        this.currAppId = appId;
        const siteId = this.currSiteId || '';
        this.getSiteMenuList(portalId, appId, siteId);
      }
    },
    getSiteMenuList(pPortalId, pAppId, pSiteId, isImport) { // get siteMenu list
      if (!pSiteId) return;
      const queryParams = {
        portalId: pPortalId,
        applicationId: pAppId,
      };
      http.request(this.$options.name, 'DTS_CMP_00020', {
        path: {
          'site-id': pSiteId,
        },
        query: queryParams,
      }).then(res => {
        if (isImport) { // 가져오기일 경우
          this.localdata1_ori = utils.cloneDeep(this.localdata1); // backup for compare
          this.localdata1 = this._setExtendInfo(res.data);
        } else {
          this.localdata1 = this._setExtendInfo(res.data);
          this.localdata1_ori = utils.cloneDeep(this.localdata1); // backup for compare
        }

        this.dsSiteMenuList.setRawData([]);
        this.dsSiteMenuList.setRawData(this.localdata1);

        const treeGridRows = this.$refs.treeGrid01.getJqxTreeGrid().getRows();

        this.setTreeGridCheckbox(treeGridRows); // set checkbox

        // this.$refs.treeGrid01.getJqxTreeGrid().expandAll();

        this.cmpStatus.copySelect = false;
        this.cmpStatus.copyBtn = false;
        // this.cmpStatus.saveBtn = utils.size(treeGridRows) > 0 ? false : true;
        this.cmpStatus.saveBtn = !(utils.size(treeGridRows) > 0);

        this.saveSnapshot(this.makeSnapshot());
      }).catch(error => {
        console.log(error);
      });
    },
    _setExtendInfo(list) {
      utils.forEach(list, data => {
        const result = {};
        result.deleteYn = data.deleteYn || 'Y'; // N = check, Y = uncheck
        if (data.finalModificationUserInfo) {
          const userInfo = data.finalModificationUserInfo;
          result['m_userName'] = userInfo.dsplLngId === this.localLangId ? userInfo.userName : userInfo.userGlobalName;
          result['m_knoxId'] = userInfo.knoxId;
        } else {
          result['m_userName'] = '';
          result['m_knoxId'] = '';
        }
        utils.assign(data, result);
      });
      return list;
    },
    onSiteSelect(selectObj) {
      this.currSiteId = selectObj.siteId || '';
    },
    onCopySiteMenuClick() {
      const portalId = this.frame0.selectData.portals.key || '';
      const appId = this.currAppId || '';
      // const siteId = this.currSiteId || '';
      const siteId = this.frame0.selectData.copySite.key || '';

      if (utils.isEmpty(utils.trim(siteId))) {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SITE'));
        utils.messageBox('warning', msg);
        return false;
      }

      this.getSiteMenuList(portalId, appId, siteId, true);
    },
    setTreeGridCheckbox(treeGridData) {
      utils.forEach(treeGridData, item => {
        // if (item.siteId) {
        if (item.deleteYn === 'N') { // N = checked
          this.$refs.treeGrid01.getJqxTreeGrid().checkRow(item.uid, true);
        }
        if (item.records) {
          this.$refs.treeGrid01.getJqxTreeGrid().expandRow(item.uid, true);
          this.setTreeGridCheckbox(item.records);
        }
      });
    },
    onSaveClick() {
      const portalId = this.frame0.selectData.portals.key || '';
      const appId = this.selectedGridRowData.applicationId;
      const siteId = this.frame0.selectData.site.key || '';

      const queryParams = {
        portalId,
        applicationId: appId,
      };

      // checked rows
      // const checkedRows = this.$refs.treeGrid01.getJqxTreeGrid().getCheckedRows();
      // const dataParams = [];
      // utils.forEach(checkedRows, item => {
      //   dataParams.push({
      //     portalId,
      //     applicationId: appId,
      //     siteId,
      //     menuUid: item.menuUid,
      //   });
      // });

      const dataParams = [];
      let saveRows = [];

      const tmpArr = [];
      utils.forEach(this.localdata1, (item, index) => {
        if (this.localdata1_ori[index].deleteYn !== item.deleteYn) {
          tmpArr.push(item);
        }
      });
      saveRows = tmpArr;

      utils.forEach(saveRows, item => {
        dataParams.push({
          portalId,
          applicationId: appId,
          siteId,
          menuUid: item.menuUid,
          deleteYn: item.deleteYn,
        });
      });

      // const targetUrl = this.saveMode === 'create' ? 'DTS_CMP_00024' : 'DTS_CMP_00057';

      http.request(this.$options.name, 'DTS_CMP_00024', {
        path: {
          'site-id': siteId,
        },
        query: queryParams,
        data: dataParams,
      }).then(res => {
        utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
          // 저장 후 재 로드
          const rowNum = this.$refs.appGrid.getJqxGrid().getselectedrowindex();
          this.onRowSelect(rowNum);
        });
      }).catch(error => {
        console.log(error);
      });
    },
    onRowCheckTreeGrid(e) {
      this._rowCheck(e.args.row.uid, 'N');
      this._downCheck(e.args.row);
      this._upCheck(e.args.row);
    },
    onRowUncheckTreeGrid(e) {
      this._rowCheck(e.args.row.uid, 'Y');
      this._downCheck(e.args.row);
      this._upCheck(e.args.row.parent);
    },
    _downCheck(obj) {
      utils.forEach(obj.records, item => {
        if (obj.checked) {
          this.$refs.treeGrid01.getJqxTreeGrid().checkRow(item.uid, true);
          this._rowCheck(item.uid, 'N');
        } else {
          this.$refs.treeGrid01.getJqxTreeGrid().uncheckRow(item.uid, true);
          this._rowCheck(item.uid, 'Y');
        }

        if (item.records) {
          this._downCheck(item);
        }
      });
    },
    _upCheck(obj) {
      if (obj) {
        this.$refs.treeGrid01.getJqxTreeGrid().checkRow(obj.uid, true);
        this._rowCheck(obj.uid, 'N');

        if (obj.parent) {
          this._upCheck(obj.parent);
        }
      }
    },
    _rowCheck(uid, value) {
      const rowNum = utils.findIndex(this.localdata1, { 'dataset-row-id': uid });
      this.localdata1[rowNum].deleteYn = value;
    },
  },
};
</script>
<style>
  .copy-site .dp_flex .sui-select {
    width:200px !important;
  }
  .comm_shut_wrap .inbox1 { flex: 1 1 30%; align-self: auto; }
  .comm_shut_wrap .inbox2 { flex: 1 1 70%; align-self: auto; }
</style>
